
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"17","height":"14","viewBox":"0 0 17 14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#C3AFA3","d":"M16.202 2.38L14.248.42a.35.35 0 00-.496 0L5.498 8.68a.35.35 0 01-.496 0L3.048 6.72a.35.35 0 00-.496 0L.598 8.68a.35.35 0 000 .495l4.404 4.405a.35.35 0 00.496 0L16.202 2.87a.35.35 0 000-.49z"}})])
          )
        }
      }
    